import { PhoneBookData } from "./PhoneBookData.interface";

export const INITIAL_PHONEBOOK_DATA: PhoneBookData = {
    type: "none",
    inverse: false,
    evn: "none"
}
